import { lazy, Suspense, type FC } from 'react';
import { type SbRespFollowSearchBannerProps } from './types.ts';

const LazyComponent = lazy(
    () =>
        import(/* webpackChunkName: "SbRespFollowSearchBanner" */ './SbRespFollowSearchBanner.tsx')
);

export const SbRespFollowSearchBannerLazy: FC<SbRespFollowSearchBannerProps> = props => (
    <Suspense fallback="">
        <LazyComponent {...props} />
    </Suspense>
);
